import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'bento-ordering/base/components/PrimaryCta';
import { fulfillmentOptions } from 'bento-ordering/cart/constants/fulfillmentOptions';

class MenuHoursExpiredNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func,
    onlineOrderingFulfillmentMethod: PropTypes.oneOf([
      fulfillmentOptions.PICKUP,
      fulfillmentOptions.DELIVERY,
      fulfillmentOptions.DINE_IN
    ])
  };

  getFulfillmentMethodDisplayText() {
    switch (this.props.onlineOrderingFulfillmentMethod) {
      case fulfillmentOptions.PICKUP:
        return 'pickup';
      case fulfillmentOptions.DELIVERY:
        return 'delivery';
      case fulfillmentOptions.DINE_IN:
        return 'dine-in';
      default:
        return '';
    }
  }

  render() {
    return (
      <NotificationModal
        title="Oops! This menu has changed"
        body={`Please set a new time for your ${this.getFulfillmentMethodDisplayText()} order. Be aware that item availability may have changed.`}
        onClose={this.props.closeModal}
      >
        <PrimaryCta
          label="Set A New Time"
          handleClick={this.props.handlePrimaryCta}
          fullWidth
        />
      </NotificationModal>
    );
  }
}

export default MenuHoursExpiredNotification;
